import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import { withRouter } from 'react-router';
import { AccessibilityWrapper, LoadingSpinner } from 'legacy-packages/ft-cb';

import { FlyoutSecondMenu } from 'chameleon/ui-stack/ui/assessments/actions/FlyoutSecondMenu';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import React from 'react';

const AnswerSheetActions = ({
  showGenerateNewAnswerSheets,
  canRenderPaperscorerAnswerSheets,
  showPaperscorerLinks,
  closePopUp,
  setModalOpen,
  hasActiveAnswersheets,
  downloadAllAnswerSheets,
  assignment_id,
  title,
  section,
  subjectName,
  loadingAllAnswerSheets,
  showDownloadAnswerSheets,
  uploadRef,
  uploadFiles,
  uploadLoading,
}) => {
  const isGenerateDisabled = !(
    showGenerateNewAnswerSheets &&
    canRenderPaperscorerAnswerSheets &&
    showPaperscorerLinks
  );

  const isDownloadDisabled = !(hasActiveAnswersheets && showPaperscorerLinks);

  const isUploadDisabled = !(
    showDownloadAnswerSheets &&
    hasActiveAnswersheets &&
    showPaperscorerLinks
  );

  const allDisabled =
    isGenerateDisabled && isDownloadDisabled && isUploadDisabled;

  return (
    <FlyoutSecondMenu
      size="auto"
      isNarrow
      className="update-labels"
      position="right-end"
      trigger={(buttonProps, isOpen, reference) => (
        <AccessibilityWrapper>
          <SingleAction
            iconName="sheet_options"
            ref={reference}
            {...buttonProps}
            disabled={allDisabled}
          >
            Answer Sheets
            <Icon id="chevron_right" className="ml-0.8 h-4 self-center" />
          </SingleAction>
        </AccessibilityWrapper>
      )}
    >
      <div role="menu">
        <ul role="group" className="p-0 m-0 pt-1 pr-6">
          <li role="menuitem" className="list-none m-0 flex justify-between">
            <AccessibilityWrapper>
              <SingleAction
                disabled={isGenerateDisabled}
                role="button"
                tabIndex="0"
                onClick={() => {
                  closePopUp();
                  setModalOpen(true);
                }}
                className="text-left"
                iconName="generate_sheet"
              >
                <span className="item-text">Generate</span>
              </SingleAction>
            </AccessibilityWrapper>
          </li>
          <li role="menuitem" className="list-none m-0 flex justify-between">
            <AccessibilityWrapper>
              <SingleAction
                disabled={isDownloadDisabled}
                role="button"
                tabIndex="0"
                onClick={() =>
                  downloadAllAnswerSheets({
                    assignmentId: assignment_id,
                    assignmentName: title,
                    sectionName: section,
                    subjectName,
                  })
                }
                className="text-left"
                iconName="download_sheet"
                title="Download Answer Sheets"
                ariaLabel="Download Answer Sheets"
              >
                <span className="item-text">Download</span>
                {loadingAllAnswerSheets && (
                  <div className="DownloadAllASBtn__loading-spinner-container">
                    <LoadingSpinner containerClassName="DownloadAllASBtn__loading-spinner" />
                  </div>
                )}
              </SingleAction>
            </AccessibilityWrapper>
          </li>
          <li role="menuitem" className="list-none m-0 flex justify-between">
            <AccessibilityWrapper>
              <SingleAction
                role="button"
                tabIndex="0"
                onClick={() => uploadRef.current.click()}
                className="text-left"
                iconName="upload_sheet"
                title="Upload Answer Sheets"
                ariaLabel="Upload Answer Sheets"
                disabled={isUploadDisabled}
              >
                <input
                  type="file"
                  multiple
                  accept=".pdf, .jpg, .png, .jpeg"
                  hidden
                  ref={uploadRef}
                  onChange={uploadFiles}
                />
                <span className="item-text">Upload</span>
                {uploadLoading && (
                  <LoadingSpinner
                    containerClassName="TableActions__upload-answer-sheets-spinner absolute top-4 right-2"
                    data-test-loading
                  />
                )}
              </SingleAction>
            </AccessibilityWrapper>
          </li>
        </ul>
      </div>
    </FlyoutSecondMenu>
  );
};

export default withRouter(AnswerSheetActions);
